import { useEffect } from "react";
import { getNestedValue, setNestedValue } from "../../../utils/object";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import { PositivoAuthenticationTypeEnum, PositivoAuthenticationTypeText, PositivoTypeEnum, PositivoTypeText } from "../../../constants/readers-model";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";

export function PartialFormPositivo({ configuration, setConfiguration, setEditablePort, ...props }) {
   useEffect(() => {
      setEditablePort(true);
      if (!configuration) {
         setConfiguration({
            type: PositivoTypeEnum.FACIAL,
         });
      }
   }, []);

   function onChange(field, value) {
      const currentValue = getNestedValue(configuration, field);
      if (currentValue === value) return;
      setConfiguration(setNestedValue({ ...configuration }, field, value));
   }

   return (
      <div className="w-full grid grid-cols-2 gap-2.5">
         <Input
            name="user"
            id="user"
            labelText="Usuário"
            value={configuration?.user}
            onChange={({ target }) => onChange('user', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="password"
            id="password"
            type="password"
            labelText="Senha"
            value={configuration?.password}
            onChange={({ target }) => onChange('password', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Select
            labelText="Tipo"
            value={configuration?.type}
            onChange={({ target }) => onChange('type', target.value)}
            disabled={props.type === "consulta"}
            required={true}
            options={[
               ...Object.entries(PositivoTypeEnum).map(([key, value]) => ({
                  value,
                  text: PositivoTypeText[value],
               }))
            ]}
         />
         <Select
            labelText="Tipo de Autenticação"
            value={configuration?.authenticationType}
            onChange={({ target }) => onChange('authenticationType', target.value)}
            disabled={props.type === "consulta"}
            required={true}
            options={[
               ...Object.entries(PositivoAuthenticationTypeEnum).map(([key, value]) => ({
                  value,
                  text: PositivoAuthenticationTypeText[value],
               }))
            ]}
         />
         <div className="flex flex-col gap-1">
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Leitora com Validação de Máscara`}
               onChange={(e) => onChange('userMaskValidation', e.target.checked)}
               selected={configuration?.userMaskValidation}
            />
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Ignora fabricante digital`}
               onChange={(e) => onChange('ignoreDigitalManufacturer', e.target.checked)}
               selected={configuration?.ignoreDigitalManufacturer}
            />
         </div>
         <Input
            name="ignoreSameTagValueTime"
            type="number"
            id="ignoreSameTagValueTime"
            labelText="Tempo ignora tag de mesmo valor (s)"
            value={configuration?.ignoreSameTagValueTime}
            onChange={({ target }) => onChange('ignoreSameTagValueTime', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
      </div>
   );
}